import classNames from "classnames"
import React from "react"

import { useTranslation } from "@bounce/i18n"
import { HeroContainer } from "@bounce/web-components"

import { SearchBar } from "../SearchBar"
import { Breadcrumbs } from "@/components/Generic/Breadcrumbs/Breadcrumbs"
import type { FormattedBlogPostPreview } from "@/libs/prismic/types"
import type { Breadcrumb } from "@/types"

import background from "./assets/background.png"

type Props = {
  articleData: FormattedBlogPostPreview[]
  className?: string
}

export const Hero = ({ articleData, className }: Props) => {
  const { t } = useTranslation("marketing-generic")

  const breadcrumbs: Breadcrumb[] = [
    {
      id: "home",
      name: t("screen.blog.breadcrumbs.home", "Home"),
      href: "/",
    },
    {
      id: "cities",
      name: t("screen.blog.breadcrumbs.blog", "Blog"),
      href: "/blog",
    },
  ]

  return (
    <HeroContainer
      image={background}
      hideImageOnMobile={false}
      className={classNames("!min-h-0", className)}
      imageClassName="!object-contain">
      <Breadcrumbs breadcrumbs={breadcrumbs} className="pb-5" />
      <h1 className="title1 mb-3 mt-1 break-words md:mb-3.5 lg:mb-5">{t("screen.blog.header", "Bounce Blog")}</h1>
      <p className="subtitle">{t("screen.blog.description", "Ideas, stories, and tips all in one place.")}</p>
      <SearchBar articleData={articleData} className="mt-8 md:mt-12 md:max-w-[512px]" />
    </HeroContainer>
  )
}
